// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

// Define a service using a base URL and expected endpoints
// Note: This service uses /v1 base path, endpoints should include full path
export const testApi = createApi({
  reducerPath: 'testApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['ACTIONS_LIST'],
  endpoints: ({ query, mutation }) => ({
    getCountries: query({
      query: () => 'v1/countries',
    }),
    editBusinessInfo: mutation({
      query: (body: any) => ({
        url: `/v1/business-operation/business-profiles/${body.id}/edit`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['ACTIONS_LIST'],
    }),
    returnBusinessInfo: mutation({
      query: (body: { rejectReason: string; id: string }) => ({
        url: `/v1/business-operation/business-profiles/${body.id}/returnToUser`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ACTIONS_LIST'],
    }),
    getBusinessList: query({
      query: (params) => ({
        url: '/v1/business-operation/business-profiles',
        params,
      }),
    }),
    getSingleRequest: query({
      query: ({ requestId }) => ({
        url: `/v1/business-operation/${requestId}`,
      }),
    }),
    getStatusLookups: query({
      query: (params) => ({
        url: '/v1/business-operation/status',
        headers: {
          'accept-language': params?.locale,
        },
      }),
    }),
    getOperationActions: query({
      query: (params) => ({
        url: `/v1/business-operation/business-profiles/${params?.id}/actions`,
        headers: {
          'accept-language': params?.locale,
        },
      }),
      providesTags: ['ACTIONS_LIST'],
    }),
    approveUserOpeartion: mutation({
      query: ({ body, id }) => ({
        url: `/v1/business-operation/business-profiles/${id}/approve`,
        method: 'POST',
        body: body,
      }),
      invalidatesTags: ['ACTIONS_LIST'],
    }),

    rejectUserOpeartion: mutation({
      query: ({ body, id }) => ({
        url: `/v1/business-operation/business-profiles/${id}/reject`,
        method: 'POST',
        body: body,
      }),
      invalidatesTags: ['ACTIONS_LIST'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCountriesQuery,
  useEditBusinessInfoMutation,
  useReturnBusinessInfoMutation,
  useGetSingleRequestQuery,
  useGetBusinessListQuery,
  useGetStatusLookupsQuery,
  useApproveUserOpeartionMutation,
  useRejectUserOpeartionMutation,
  useGetOperationActionsQuery,
} = testApi;
